/* eslint-disable max-len */

export const Constants = {
  acceptTerms:
    'Declaro que aceito os *Termos de uso* e a *Política de privacidade.*',
  cancel: 'cancelar',
  confirm: 'confirmar',
  confirmHelp: 'as senhas devem ser iguais',
  confirmPassword: 'confirme a nova senha',
  cpf: 'CPF',
  email: 'e-mail principal',
  left: ' segundos restantes',
  newToken: 'solicitar novo código',
  password: 'digite a nova senha',
  passwordHelp:
    'mínimo de 8 caracteres com letra mínuscula, maiúscula e número',
  typeEmail: 'digite seu e-mail',
  expiredToken:
    'O prazo para realizar o cadastro de senha expirou. Solicite novamente o email.',
  sendToken: 'enviar novo email',
  responsibleName: 'nome do responsável',
  seconds: '0:',
};
